export const helpText: HelpInfoData = {
    // Filter descriptions
    'Date Range': [
        {
            title: 'Activity Date:',
            paragraph:
                'The last time a contact visited your website or accessed content provided.  For new leads, this date will be the same as the Registration Date until they return.  This date is also used for calculating the consent period.',
        },
        {
            title: 'Registration Date:',
            paragraph: 'A date contact submitted their contact information for the first time.',
        },
        {
            title: 'Channel Date:',
            paragraph:
                'Last activity for a given communication channel. (ex. Text msg., voice call, etc.)',
        },
    ],
    Channel: [
        /* {
            title: 'Action Plans:',
            paragraph: 'Include all sent and received communication events that are part of an Action Plan assigned to a contact.',
        }, */
        {
            title: 'Calls:',
            paragraph:
                'Include all dial-out and dial-in voice call events. Works in combination with the Channel Date field above.',
        },
        {
            title: 'Email Events:',
            paragraph:
                'Include all sent and received email events. Works in combination with the Channel Date field above.',
        },
        {
            title: 'Text Messages:',
            paragraph:
                'Include all sent and received text (SMS) events. Works in combination with the Channel Date field above.',
        },
    ],
    // Create contact consents
    Consents: [
        {
            title: 'pPolicy',
            paragraph:
                'I confirm this lead was provided instructions or a link to access a Privacy Policy indicating how I use their personal information.',
        },
        {
            title: 'consent',
            paragraph:
                'I confirm this lead provided express consent to being contacted using the personal information they provided.',
        },
        {
            title: 'terms',
            paragraph:
                'I confirm that I have read and understood this policy for new and imported leads and agree to accept responsibility for compliant use of Stay In Contact.',
        },
    ],
    // New recent filter description
    /* 'Filter Section': [
        {
            title: 'Filter Direction Buttons',
            paragraph: 'You can use These buttons to filter your list as either "income" or "outgoing" or both selected',
        },
        {
            title: 'Search Input',
            paragraph: 'Once clicked, a right side drawer will be opened for advanced filtering.',
        },
        {
            title: 'Filter Icon',
            paragraph: 'It shows if any filter is being used based on the icon displayed. A star icon represents a filter that is set as your default. A gray funnel means that the system default is being used. A red funnel means a filter is applied but is none of the other two options.',
        },
    ], */
    'List Section': [
        {
            title: '1. Contact Badge',
            paragraph: `The Contact Badge typically displays the first letter of the given name of a contact. Look for a single letter representing the contact's first name.`,
        },
        {
            title: '2. Unread/Unheard Communication',
            paragraph: `This section indicates the presence of unread or unheard messages. The number displayed represents the count of unread or unheard messages. Pay attention to this number to determine the quantity of messages awaiting your attention.`,
        },
        {
            title: '3. Contact Name',
            paragraph: `The Contact Name section shows up to 16 characters of the contact's first, last, and middle name. If a name exceeds this character limit, it will be truncated and displayed with an ellipsis (...). The purpose is to provide a concise representation of the contact's name.`,
        },
        {
            title: '4. Last Inbound Channel Content',
            paragraph: `This section provides a snippet of the content from the last message sent or received. It offers a glimpse of the message's content without displaying the entire message. This snippet can help you quickly recall the context of the conversation.`,
        },
        {
            title: '5. Last Message Direction',
            paragraph: `The Last Message Direction indicates whether the last message was inbound (received) or outbound (sent). It helps identify whether you sent the last message or received it from the contact.`,
        },
        {
            title: '6. Last Message Channel Type',
            paragraph: `This section displays a graphic representation of the last channel type used for sending or receiving communication. It is associated with the Last Message Direction. The graphic represents the following channel types:`,
        },
        {
            title: '7. Date of Last Action',
            paragraph: `The Date of Last Action is depicted by the names of the days of the week for the first seven days. After that, the actual date of the last message is provided. Pay attention to this information to determine when the last communication occurred.`,
        },
    ],
    'Gmail Setup': [
        {
            title: '1.',
            paragraph:
                'Go to <a href="https://myaccount.google.com/?pli=1" target="_blank" rel="noopener noreferrer">Manage your Google Account</a> and On the left-hand side, click <a href="https://myaccount.google.com/security" target="_blank" rel="noopener noreferrer">Security.</a>',
        },
        {
            title: '2.',
            paragraph:
                'In the <strong>How you sign in to Google</strong> section, you should see a green check mark icon next to 2-Step Verification (see image below)',
        },
        {
            title: '3.',
            paragraph:
                'Click on <strong>Search Google Account</strong> and type "app password" and hit enter. (you will have to log in again)',
        },
        {
            title: '4.',
            paragraph:
                'Click on the <strong>Select app</strong> dropdown menu and select <strong>Mail</strong>',
        },
        {
            title: '5.',
            paragraph:
                'Click on the <strong>Select device</strong> dropdown menu and select <strong>Other (Custom Name)</strong>',
        },
        {
            title: '6.',
            paragraph: 'Type in the name of the service (ex. CRM Email, SuccessWebsite, etc.)',
        },
        {
            title: '7.',
            paragraph:
                'Click the <strong>GENERATE</strong> button.  This will present you with a popup in which an app-specific password will be used. You will have to copy the 16 character password directly into the password field of your EngageCRM email setup page. <strong>Do not click Done</strong> until you click <strong>Test & Save</strong> in Stay in Contact and you know the password was accepted. You will not be able to see the password once you click <strong>Done.</strong>',
        },
        {
            title: '8.',
            paragraph:
                'You can now go back to the User Email Setup page, select Gmail/Google Workspace, click on the blue button "I have read the...", enter your email address and paste the password.  When you receive the Success message you can close all windows.',
        },
        /* {
            title: 'Please Note:',
            paragraph: 'Google will send you two emails both titled "Security alert". This is in order to inform you an application specific password has been generated.  You can just disregard them for this occasion.'
        } */
    ],
    'Office 365 Setup': [
        {
            title: '1.',
            paragraph:
                'Go to the following link: <a href="https://account.live.com/proofs/Manage/additional" target="_blank" rel="noopener noreferrer">https://portal.office.com/account/#security</a>',
        },
        {
            title: '2.',
            paragraph: 'Scroll down to the "App password" section',
        },
        {
            title: '3.',
            paragraph: 'Click on the "Create a new password" link.',
        },
        {
            title: '4.',
            paragraph:
                'Copy the password and paste it in the password field in your StayInContact email settings.',
        },
        {
            title: 'GoDaddy.',
            paragraph:
                'GoDaddy (using Office 365): <a href="https://ca.godaddy.com/help/create-app-passwords-40980" target="_blank" rel="noopener noreferrer">https://ca.godaddy.com/help/create-app-passwords-40980</a>',
        },
    ],
};

export type HelpInfoData = {
    [key: string]: HelpInfoItem[];
};

export type HelpInfoItem = {
    title: string;
    paragraph: string;
};
